import axios from 'axios';
import {BASE_URL} from '@/utils/config';

export const getAllShatayushiMembersData = async () => {
	try {
		const response = await axios.get(`${BASE_URL}/shatayushi-member/get-all`);
		return response.data;
	} catch (error) {
		console.log("(eventApi.js) Error while fetching details of all Shatayushi Members: ", error);
	}
}
